import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-film';
export var ID = 'icon-film';
/* eslint-disable max-len */

export var SVGFilm = function SVGFilm() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 69 69"
  }, React.createElement("path", {
    d: "M0 1.166v66.668C0 68.514.486 69 1.166 69h66.668c.68 0 1.166-.486 1.166-1.166V1.166C69 .486 68.514 0 67.834 0H1.166C.486 0 0 .486 0 1.166zm22.546 3.402h6.415c.68 0 1.167.486 1.167 1.166v6.414c0 .68-.486 1.166-1.166 1.166h-6.414c-.68 0-1.166-.486-1.166-1.166V5.734c0-.68.486-1.166 1.166-1.166zm20.02 28.28c.875.875.875 2.43 0 3.304l-12.73 12.73c-1.46 1.46-3.985.39-3.985-1.65V21.768c0-2.14 2.527-3.11 3.985-1.653l12.73 12.73zM11.468 64.432H5.054c-.68 0-1.167-.486-1.167-1.166v-6.414c0-.68.486-1.166 1.167-1.166h6.414c.68 0 1.166.486 1.166 1.166v6.414c0 .68-.486 1.166-1.166 1.166zm0-51.118H5.054c-.68 0-1.167-.486-1.167-1.166V5.734c0-.68.486-1.166 1.167-1.166h6.414c.68 0 1.166.486 1.166 1.166v6.414c0 .583-.486 1.166-1.166 1.166zM28.96 64.432h-6.414c-.68 0-1.166-.486-1.166-1.166v-6.414c0-.68.486-1.166 1.166-1.166h6.415c.68 0 1.167.486 1.167 1.166v6.414c0 .68-.486 1.166-1.166 1.166zm17.494 0H40.04c-.68 0-1.167-.486-1.167-1.166v-6.414c0-.68.486-1.166 1.166-1.166h6.414c.68 0 1.166.486 1.166 1.166v6.414c0 .68-.486 1.166-1.166 1.166zm0-51.118H40.04c-.68 0-1.167-.486-1.167-1.166V5.734c0-.68.486-1.166 1.166-1.166h6.414c.68 0 1.166.486 1.166 1.166v6.414c0 .583-.486 1.166-1.166 1.166zm17.492 51.118h-6.414c-.68 0-1.166-.486-1.166-1.166v-6.414c0-.68.486-1.166 1.166-1.166h6.414c.68 0 1.167.486 1.167 1.166v6.414c0 .68-.486 1.166-1.167 1.166zm0-51.118h-6.414c-.68 0-1.166-.486-1.166-1.166V5.734c0-.68.486-1.166 1.166-1.166h6.414c.68 0 1.167.486 1.167 1.166v6.414c0 .583-.486 1.166-1.167 1.166z",
    fillRule: "evenodd"
  }));
};
/* eslint-disable max-len */

var Film = function Film(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGFilm
  });
};

Film.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Film;